import React from 'react';
import { ICacheContext } from 'framework/context/ICacheContext';
import { IGeneralPractitionersSearchData } from 'gen/ApiClient';

export const GeneralPractitionersFilterDataContext = React.createContext<ICacheContext<IGeneralPractitionersSearchData>>(undefined as any);
